export default __webpack_public_path__ + "static/media/close-modal.0224a62a.svg";